export default ({
    wire,
    modelName,
    maxFileUploads = 40,
    maxFileSize = 2097152,   // 2 MB
    maxFileSizeText = "2 MB",   // 2 MB
    maxFileUploadsAtOnce = 20,
}) => ({
    maxFileUploads: maxFileUploads,
    maxFileSizeText: maxFileSizeText,
    isUploading: false,
    progress: 0,
    files: wire.entangle(modelName),
    counter: 0,
    /*
     * Cuenta los archivos subidos.
     * Por alguna razón, el entangle con un modelo que se usa para la carga de archivos
     * devuelve una string con un arreglo dentro con los nombres de los archivos entre comillas.
     * Esto solo pasa si se hay más de un archivo, cuando no, si devuelve una array.
     */
    filesCount() {
        if (typeof this.files === "string") {
            let matches = this.files.split('"').length - 1;
            return matches / 2;
        } else {
            return this.files.length;
        }
    },
    // Dice si se alcanzó el límite de subidas.
    reachedMaxFileUploads() {
        return this.filesCount() >= maxFileUploads;
    },
    isDropping() {
        return Boolean(this.counter)
    },
    // Dice cantidad de archivos restantes que se pueden subir.
    leftFileUploads() {
        return Math.abs(maxFileUploads - this.filesCount());
    },
    // Se llama cuando se seleccionan archivos.
    handleFileSelect(event) {
        if (event.target.files.length) {
            this.upload([...event.target.files])
            event.target.value = null
        }
    },
    // Se llama cuando se sueltan archivos.
    handleFileDrop(event) {
        this.counter = 0

        let files = [...event.dataTransfer.files].filter(file => file.type || file.size % 4096 != 0);

        if (files.length) {
            this.upload(files)
        }
    },
    handleDragOver(event) {
        event.dataTransfer.dropEffect = 'copy';
    },
    handleDragEnter(event) {
        this.counter++
    },
    handleDragLeave(event) {
        this.counter--;
    },
    sanitise(files) {
        files = files.filter(file => file.size > 0)

        let discardedFiles = []
        let validFiles = []

        files.forEach(function (file) {
            if (file.size <= maxFileSize) {
                validFiles.push(file)
            } else {
                discardedFiles.push(file)
            }
        });
        files = validFiles;

        if (discardedFiles.length > 0) {
            let message = `Los siguientes archivos tienen un tamaño mayor al permitido y se omitirán: `

            message = discardedFiles.reduce(
                (text, file, index) => text + `${file.name}` + (index + 1 === discardedFiles.length ? '' : ', '),
                message
            )

            window.dispatchEvent(new CustomEvent('toastify-js', { detail: {
                id: 'warning-notification',
                title: 'Archivos demasiado grandes',
                message: message,
                duration: 3000 * discardedFiles.length,
            }}));
        }
        return files;
    },
    // Punto de entrada para cargar archivos. Verifica que todavía se puedan agregar más archivos
    upload(files) {
        files = this.sanitise(files)

        let leftFileUploads = this.leftFileUploads();

        if (files.length > leftFileUploads) {
            window.dispatchEvent(new CustomEvent('toastify-js', { detail: {
                id: 'warning-notification',
                title: 'Limite alcanzado',
                message: `Imposible cargar más archivos, el límite es ${maxFileUploads}.`
            }}));
        }

        if (leftFileUploads !== 0) {
            // Reducimos el tamaño del arreglo al máximo de archivos restante
            files = files.slice(0, Math.min(leftFileUploads, files.length));
            this.uploadChunks(files, maxFileUploadsAtOnce);
        }
    },
    /* Permite dividir los archivos a subir en chunks. Esto se hace para poder cargar muchos
       archivos a la vez a la vista del usuario, pero en realidad se hacen varias peticiones,
       ya que existe un límite. */
    uploadChunks(files, chunkSize) {
        let chunks = Math.ceil(files.length / chunkSize);

        for (let i = 0; i < chunks; i++) {
            let chunk = files.slice(
                i * chunkSize,
                (i + 1) * chunkSize
            );
            this.uploadOneChunk(chunk);
        }
    },
    // Carga un solo chunk de archivos
    uploadOneChunk(files) {
        const $this = this;
        this.isUploading = true;

        wire.uploadMultiple(modelName, files,
            function () {
                $this.isUploading = false;
                $this.progress = 0;
            },
            function() {
                window.dispatchEvent(new CustomEvent('toastify-js', { detail: {
                        id: 'error-notification',
                        title: 'Error',
                        message: 'Hubo un error desconocido al cargar los archivos.'
                    }}));
            },
            function (event) {
                $this.progress = event.detail.progress;
            }
        );
    },
    // Remueve un archivo cargado
    removeUpload(filename) {
        wire.removeUpload(modelName, filename);
    },
    // Remueve todos los archivos
    removeAllUploads() {
        wire.set(modelName, []);
    },
});
